import React, { forwardRef } from 'react';

import { Preview } from './preview';
import type { Props } from './use-preview';

import type { PhoneNumberRef } from '../types';
import { UpdatePhoneNumber } from '../update/update-phone-number';

function PreviewPhoneNumberBase(props: Props, ref: React.Ref<PhoneNumberRef>) {
  const { isEditable, validateDuplicatePhoneNumber } = props;

  if (isEditable) {
    return <UpdatePhoneNumber ref={ref} {...props} validateDuplicatePhoneNumber={validateDuplicatePhoneNumber} />;
  }

  return <Preview {...props} />;
}

export const PreviewPhoneNumber = React.memo(forwardRef<PhoneNumberRef, Props>(PreviewPhoneNumberBase));
